/** Angular Imports */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable } from 'rxjs';

/** Custom Services */
import { ProductsService } from '../products.service';

/**
 * Recurring Deposit Product data resolver.
 */
@Injectable()
export class RecurringDepositProductResolver {
  private productsService = inject(ProductsService);

  /**
   * Returns the recurring deposit product data.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const productId = route.parent.paramMap.get('productId');
    return this.productsService.getRecurringDepositProduct(productId);
  }
}
